import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { CustomerAccStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetCustomerListing(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCustomerListingAttempt', handleGetCustomerListing, api);
}

function* handleGetCustomerListing(api: CustomerGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { status, branchName, name, idNo, dateFrom, dateTo } } = reduxState.customer.customerListing;
    const allBranches = reduxState.branch.allBranches;

    const convertedStatus = UtilFunctions.Misc.getEnumValueByKey(CustomerAccStatusEnum, status);
    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    if (!index && index !== 0) {
        yield put(combinedActions.customerGetCustomerListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    // if status is passed but not a valid status
    if (status && !convertedStatus) {
        yield put(combinedActions.customerGetCustomerListingFailure(ErrorMessages.FilterInvalidStatusError));
        toast.error(ErrorMessages.FilterInvalidStatusError);
        return;
    }

    const response = yield* call([api, api.getCustomerListing], {
        authToken,
        index,
        status: convertedStatus,
        branchCode: branchCode || undefined,
        name: name || undefined,
        idNo: idNo || undefined,
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCustomerListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCustomerListingSuccess(response.data));
    }
}
